import React from 'react';
import {useCitiesContext} from "../../context/CitiesContext";
import {useTvChannelsContext} from "../../context/TvChannelsContext";

function TariffTypeMain(props) {
    const queryString = require("query-string")
    const {selectedCity, selectedMunicipality} = useCitiesContext()
    const {location, history} = useTvChannelsContext()

    const selectTariffModel = (tariffModel) => {
        if(selectedCity && selectedMunicipality) {
            const params = queryString.parse(location.search)
            params.tariffType = props.tt.tariffType.id
            params.tariffModel = tariffModel.id

            history.push({
                pathname: location.pathname,
                search: queryString.stringify(params)
            })
        }
    }

    const tariffModelClassName = (tariffModel) => {
        let className = ""
        if(!selectedCity || !selectedMunicipality) {
            className = "tariffModel disabled"
        } else if (tariffModel.id == props.selectedTariffModel) {
            className += "tariffModel selected"
        }

        return className
    }
    
    return (
        <div className="col-auto">
            <div className="tariff-type">
                 {/*onClick={() => props.toggleTariffChangeModal(`/tv-channels?tariffType=${props.tt.tariffType.id}`)}>*/}
                {props.tt.tariffType.name}
            </div>
            <div className="tariff-model">
                {props.tt.tariffModels.map(tm => {
                    return (<span
                        onClick={() => selectTariffModel(tm)}
                        className={tariffModelClassName(tm)}>
                        {props.tariffModelShortNames && props.tariffModelShortNames[tm.id] ? props.tariffModelShortNames[tm.id] : tm.name}
                    </span>)
                })}
            </div>
        </div>
    );
    
    
};

export default TariffTypeMain;
